import { createStore } from 'vuex'

const store =  createStore({
  state () {
    return {
      loginStatus:true,
      loadingStatus:false,
      progressStatue:false,
      progressValue:0,
      actionResult:null,
      progress:-1,
      menuToggled:false,
      breadcrumbView:{
      },
      nowPage:''
    }
  },
  getters: {
  },
  mutations: {
    setBreadcrumb(state,data){
      state.breadcrumbView = data
    },
    updateBreadcrumb(state,data){
      state.breadcrumbView.path[data.index][data.key] = data.value
    },
    setLoadingStatus(state, status) {
      state.loadingStatus = status;
    },
    setProgress(state, value) {
      state.progress = value;
    }
  },
  actions: {
  },
  modules: {
  }
})

// 訂閱者邏輯
store.subscribe((mutation, state) => {
  if (mutation.type === 'setLoadingStatus' && state.loginStatus === false) {
    store.commit('setProgress', -1);
  }
});


export default store